import { z } from 'zod';
import { driverSchema } from './driver.schema';

export const driverPagedCollectionSchema = z.object({
  href: z.string().nullable(),
  offset: z.number(),
  limit: z.number(),
  size: z.number(),
  data: z.array(driverSchema),
});
